import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

export const AuthCodeGuard: CanActivateFn = () => {
  const cookieService = inject(CookieService);
  const router = inject(Router);

  const authToken = cookieService.get('auth-token');

  const isAuthenticated = authToken && authToken.length > 0;
  if (isAuthenticated) {
    return true;
  } else {
    return new RedirectCommand(router.parseUrl('/'));
  }
};
